function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.98 0H3.424A3.423 3.423 0 000 3.423v18.556a3.423 3.423 0 003.423 3.423h9.152l.015-9.078h-2.358a.556.556 0 01-.556-.554l-.012-2.926a.556.556 0 01.556-.558h2.355V9.459c0-3.281 2.003-5.068 4.93-5.068h2.402c.307 0 .556.249.556.556v2.468a.557.557 0 01-.556.556l-1.473.001c-1.592 0-1.9.756-1.9 1.866v2.448h3.497c.334 0 .592.29.553.622l-.347 2.926a.556.556 0 01-.552.49H16.55l-.016 9.078h5.446a3.423 3.423 0 003.423-3.423V3.423A3.423 3.423 0 0021.98 0",
  fill: "#808285"
});

var SvgLogoFacebook = function SvgLogoFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 25.402 25.402",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-facebook.2dac9af6.svg";
export { ForwardRef as ReactComponent };